import { defineComponent as _defineComponent } from 'vue'
import {
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  Heading,
  Modal
} from '@warrenbrasil/nebraska-web';
import {
  EPortfolioAboutAction,
  EPortfolioAboutButtonStyle,
  IPortfolioAboutDetails
} from '../../services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailModalV2',
  props: {
    details: null,
    isOpen: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const router = useRouter();





function handleButtonAction(action: EPortfolioAboutAction) {
  switch (action) {
    case EPortfolioAboutAction.CLOSE:
      emit('close');
      break;
    case EPortfolioAboutAction.GO_TO_COSTS:
      router.push({ name: 'costs' });
      break;
  }
}

return { __sfc: true,router, emit, handleButtonAction, BaseText, ButtonContainer, ButtonPrimary, ButtonSecondary, Heading, Modal, EPortfolioAboutButtonStyle, NebraskaColors }
}

})